import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff6250e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center flex-wrap fila px-3 py-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-medium-emphasis ms-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-wrap justify-end ejercitos ms-auto"
}
const _hoisted_4 = ["disabled", "aria-label", "onClick"]
const _hoisted_5 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_6 = ["disabled", "aria-label", "onClick"]

import { computed } from "vue";
import { JugadorListas, ListaDeJugador } from "@/interfaces/Lista";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilaListasJugador',
  props: {
    jugador: {},
    cargandoLista: {}
  },
  emits: ["ver", "perfil"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Sus listas agrupadas por ejército, en el orden en que las entregó
const grupos = computed(() => {
  const porEjercito = new Map<string, ListaDeJugador[]>();
  for (const lista of props.jugador.listas)
    porEjercito.set(lista.ejercito, [...(porEjercito.get(lista.ejercito) ?? []), lista]);
  return [...porEjercito.entries()].map(([ejercito, listas]) => ({ ejercito, listas }));
});


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "nick sin-desbordar",
      role: "link",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('perfil', _ctx.jugador.idUsuario))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('perfil', _ctx.jugador.idUsuario)), ["enter"]))
    }, _toDisplayString(_ctx.jugador.nick), 33),
    (_ctx.jugador.listas.length === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Sin lista"))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupos.value, (grupo) => {
            return (_openBlock(), _createElementBlock("div", {
              key: grupo.ejercito,
              class: "d-flex align-center ga-2"
            }, [
              (grupo.listas.some(l => l.idLista === _ctx.cargandoLista))
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "12",
                    width: "2"
                  }))
                : _createCommentVNode("", true),
              (grupo.listas.length === 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "ejercito text-body-2",
                    disabled: _ctx.cargandoLista === grupo.listas[0].idLista,
                    "aria-label": `Ver la lista de ${_ctx.jugador.nick}: ${grupo.ejercito}`,
                    onClick: ($event: any) => (emit('ver', _ctx.jugador, grupo.listas[0]))
                  }, _toDisplayString(grupo.ejercito), 9, _hoisted_4))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(grupo.ejercito), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.listas, (lista, n) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: lista.idLista,
                        type: "button",
                        class: "ejercito numero text-body-2",
                        disabled: _ctx.cargandoLista === lista.idLista,
                        "aria-label": `Ver la lista ${n + 1} de ${_ctx.jugador.nick}: ${grupo.ejercito}`,
                        onClick: ($event: any) => (emit('ver', _ctx.jugador, lista))
                      }, _toDisplayString(n + 1), 9, _hoisted_6))
                    }), 128))
                  ], 64))
            ]))
          }), 128))
        ]))
  ]))
}
}

})